import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';

import { TermsConditionsComponent } from '@terms-conditions/terms-conditions/terms-conditions.component';
import { TermsRoutingModule } from '@terms-conditions/terms-routing.module';
import { GlobalPipesModule } from '@app/pipes/global-pipes.module';
import { ModalModule } from '@ux/components/modal/modal.module';
import { TermsAndConditionsBRComponent } from '@terms-conditions/terms-conditions/br/terms-conditions-br.component';
import { TermsAndConditionsMXComponent } from '@terms-conditions/terms-conditions/mx/terms-conditions-mx.component';
import { TermsAndConditionsArComponent } from '@terms-conditions/terms-conditions/ar/terms-and-conditions-ar.component';
import { TermsAndConditionsPeComponent } from '@terms-conditions/terms-conditions/pe/terms-and-conditions-pe.component';
import { TermsAndConditionsClComponent } from '@terms-conditions/terms-conditions/cl/terms-and-conditions-cl.component';
import { TermsAndConditionsUYComponent } from '@terms-conditions/terms-conditions/uy/terms-conditions-uy.component';

@NgModule({
  declarations: [
    TermsConditionsComponent,
    TermsAndConditionsBRComponent,
    TermsAndConditionsMXComponent,
    TermsAndConditionsArComponent,
    TermsAndConditionsPeComponent,
    TermsAndConditionsClComponent,
    TermsAndConditionsUYComponent,
  ],
  exports: [
    TermsConditionsComponent
  ],
  imports: [
    CommonModule,
    TermsRoutingModule,
    GlobalPipesModule,
    TranslocoModule,
    ModalModule
  ]
})
export class TermsModule { }
